import * as React from "react";
import * as _ from "lodash";
import {translate} from "react-i18next";

// services
import {RoleDto, PrivilegeDto} from "../../../services/Client";

// reducer
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";

// semantic
import {Modal, Table} from "semantic-ui-react";

import Button from "../../../components/Button";
import Textfield from "../../../components/TextField";
import PrivilegeSelection from "./PrivilegeSelection";

export interface IRoleCreationDialogProps extends ITranslatedComponent {
    /** All existing roles. Used to check for duplicates. */
    roles: RoleDto[];

    /** All available privileges. Possible privileges for the new role. */
    privileges: PrivilegeDto[];

    /** Callback when the user closes the dialog. */
    onClose?: (newRole?: RoleDto) => any;
}

interface IRoleCreationDialogState {
    /** The name of the new role. */
    name: string;

    /** The set of privileges of the new role. */
    privileges: PrivilegeDto[];
}

/**
 * The RoleCreationDialog collects all necessary information for
 * creating a new role. The component doesn't create the role itself
 * but passes a RoleDto to it's client through onClose() which is
 * expected to call the back end API to create the role.
 */
export class RoleCreationDialog extends React.Component<IRoleCreationDialogProps, IRoleCreationDialogState> {
    constructor(props: IRoleCreationDialogProps) {
        super(props);

        this.state = {
            name: "",
            privileges: [],
        };
    }

    validateInput = (existingRoles: RoleDto[], existingPrivileges: PrivilegeDto[]): boolean => {
        const containsRole = (name: string, roles: RoleDto[]): boolean => {
            return _.find(roles, role => role.name.toLowerCase() === this.state.name.toLowerCase()) !== undefined;
        };

        // TODO: check the name for proper format&characters!
        const nameOk = Boolean(this.state.name) && !containsRole(this.state.name, existingRoles);
        const privilegesOk = this.state.privileges.length !== 0;
        return nameOk && privilegesOk;
    }

    onClickCreate = (): void => {
        if (this.props.onClose) {
            this.props.onClose({
                name: this.state.name,
                privileges: this.state.privileges,
                objectId: 0, // dummy objectId for creation
                versionId: 0, // dummy versionId for creation
            });
        }
    }

    onClickCancel = (): void => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    renderNameControl = (): JSX.Element => (
        <Textfield
            placeholder={this.props.t("ENTER_ROLE_NAME")}
            onChange={(event: React.FormEvent<{}>, newValue: string) => {
                this.setState({name: newValue});
            }}
        />
    )

    renderPrivilegesControl = (existingPrivileges: PrivilegeDto[]): JSX.Element => (
        <PrivilegeSelection
            placeholder={this.props.t("SELECT_PRIVILEGES")}
            privileges={this.props.privileges}
            values={this.state.privileges}
            onChange={(privileges: PrivilegeDto[]) => {
                this.setState({privileges: privileges});
            }}
        />
    )

    renderContent = (existingRoles: RoleDto[], existingPrivileges: PrivilegeDto[]): JSX.Element => (
        <>
            <Table definition={true}>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>{this.props.t("ROLE_NAME")}*</Table.Cell>
                        <Table.Cell>{this.renderNameControl()}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("PRIVILEGES")}*</Table.Cell>
                        <Table.Cell>{this.renderPrivilegesControl(existingPrivileges)}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            * {this.props.t("MANDATORY_FIELD")}
        </>
    )

    render() {
        const {roles, privileges} = this.props;
        return (
            <Modal open={true} style={{"marginTop": 0}}>
                <Modal.Header>{this.props.t("ADD_ROLE")}</Modal.Header>
                <Modal.Content>
                    {this.renderContent(roles, privileges)}
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        icon={"checkmark"}
                        disabled={!this.validateInput(roles, privileges)}
                        onClick={this.onClickCreate}
                    />
                    <Button
                        icon={"ban"}
                        onClick={this.onClickCancel}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

export default translate("ADMIN_VIEW")(RoleCreationDialog);



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/RoleCreationDialog.tsx